// Angular Files
import {
    Component,
    Inject,
    NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// Teller Online Files
import { ConfirmCodeRequestTypeEnumDto } from 'apps/public-portal/src/app/core/api/TellerOnlineIdentityApiClients';
import { CodeVerificationModule } from 'apps/public-portal/src/app/shared/components/code-verification/code-verification.component';

// Teller Online Library Files
import { TellerOnlineAppService } from 'teller-online-libraries/core';
import { TellerOnlineMessageService } from 'teller-online-libraries/shared';

@Component({
    selector: 'app-email-verify',
    templateUrl: './email-verify.component.html',
    styleUrls: ['./email-verify.component.scss'],
    host: {
        class: 'email-verify'
    },
    standalone: false
})
export class EmailVerifyComponent {
    public requestType: ConfirmCodeRequestTypeEnumDto = ConfirmCodeRequestTypeEnumDto.Email;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: EmailVerifyOptions,
        public dialogRef: MatDialogRef<EmailVerifyComponent>,
        public appService: TellerOnlineAppService,
        private messageService: TellerOnlineMessageService
    ) {}

    async onVerifyCode_closeModal() {
        this.messageService.notification('Your email has been confirmed.', 'success', 1500);
        this.dialogRef.close(true);
    }
}

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        CodeVerificationModule
    ],
    declarations: [EmailVerifyComponent],
    exports: [EmailVerifyComponent]
})
export class EmailVerifyModule { }

class EmailVerifyOptions {
    email: string;

    codeSent: boolean = true;

    // Called each time the user resends the code from inside the dialog
    onCodeSent?: () => void;
}
